import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-600 via-orange-500 to-red-600 text-white py-20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMGJ1c2luZXNzfGVufDB8fHx8MTc2NDM2MzY4MXww&ixlib=rb-4.1.0&q=85"
            alt="Legal business background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-orange-600/75 via-orange-500/75 to-red-600/80"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Privacy Policy</h1>
            <p className="text-xl text-orange-100">Last Updated: January 2025</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Corporate Marking ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Information We Collect</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Name, email address, and contact information</li>
              <li>Business information and trademark details</li>
              <li>Payment and billing information</li>
              <li>Communications with our team</li>
              <li>Information about your use of our services</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Provide, maintain, and improve our trademark services</li>
              <li>Process your transactions and send related information</li>
              <li>Communicate with you about services, updates, and promotional offers</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Comply with legal obligations and protect our rights</li>
              <li>Detect, prevent, and address technical issues or fraud</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Information Sharing</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Service providers who assist in our operations</li>
              <li>Professional advisors and legal counsel</li>
              <li>Government agencies as required by law</li>
              <li>Third parties in connection with business transfers</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Data Security</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Your Rights</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-6">
              <li>Access and receive a copy of your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Object to processing of your information</li>
              <li>Withdraw consent where applicable</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Cookies and Tracking</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We use cookies and similar tracking technologies to track activity on our website and store certain information. You can instruct your browser to refuse all cookies or indicate when a cookie is being sent.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <ul className="list-none text-gray-700 space-y-2 mb-6">
              <li>Email: privacy@corporatemarking.com</li>
              <li>Phone: +1 (855) 350 1458</li>
              <li>Address: 515 Flower St, Los Angeles, CA 90071</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};